import {defineMessages} from 'react-intl';

export default defineMessages({
	phoneLabel: {
		id: 'forms.fields.phoneNumber.label',
		defaultMessage: 'Phone Number',
	},
});
